import { combineReducers } from 'redux'

import date from './date'
import reviewStatus from './reviewStatus'
import searchText from './searchText'
import sessionStatus from './sessionStatus'
import chatStatus from './chatStatus'

export default combineReducers({
  date,
  reviewStatus,
  searchText,
  sessionStatus,
  chatStatus,
})
